import { handleActions } from "redux-actions";

import { setCountries } from "./actions";

const initialState = {
    isLoading: false,
    countries: {},
    ids: []
};

export const countriesReducer = handleActions(
    {
        [setCountries]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);